// Shared width + horizontal padding for every _site+ surface (nav,
// footer, page content). Introduced 2026-08-21 after two independent
// misalignment bugs traced to the same root: max-w-7xl + px-6 was authored
// inline on every surface, and any drift showed up as either double navbars
// or content-inset-from-header. Single source of truth here.
//
// Width tiers reflect the three shapes _site+ actually uses:
//   - 'narrow' (max-w-3xl) : text-first pages (privacy, terms, security,
//                            about) - comfortable line length for prose.
//   - 'default' (max-w-5xl): app-shape pages (/try) - roomier than prose
//                            but not spread across a wide viewport.
//   - 'wide' (max-w-7xl)   : nav, footer, homepage, gallery, /more - full
//                            marketing width. This is the reference all
//                            three surfaces must agree on for left/right
//                            edges to line up.
//
// px-6 is always applied. If a caller needs edge-to-edge (e.g. a full-
// bleed background), render its own div; do not add an escape hatch here.

import * as React from 'react'
import { cn } from '#app/lib/utils.ts'

type Width = 'narrow' | 'default' | 'wide'

const WIDTHS: Record<Width, string> = {
	narrow: 'max-w-3xl',
	default: 'max-w-5xl',
	wide: 'max-w-7xl',
}

export function SiteContainer({
	width = 'wide',
	className,
	children,
	as: Tag = 'div',
	id,
}: {
	width?: Width
	className?: string
	children: React.ReactNode
	as?: 'div' | 'main' | 'section' | 'header' | 'footer' | 'nav'
	id?: string
}) {
	return (
		<Tag id={id} className={cn('mx-auto w-full px-6', WIDTHS[width], className)}>
			{children}
		</Tag>
	)
}
